import { httpTokenCommon } from "../../helper/http-common";

class PaymentService {
  getPaymentDashboardCountAPI(inputData) {
    return httpTokenCommon.post("Payment/GetPaymentDashboardCounts", inputData);
  }
  getPaymentBarChartDataAPI(inputData) {
    return httpTokenCommon.post("Payment/GetPaymentDashboardData", inputData);
  }
  getPaymentCurrencyWiseDataAPI(inputData) {
    return httpTokenCommon.post("Payment/GetTotalPendingAmount", inputData);
  }
  getPaymentCustomerOutstandingGraphAPI(inputData) {
    return httpTokenCommon.post(
      "Payment/GetCustomerOutstandingReport",
      inputData
    );
  }
  getPaymentCustomerAgeingDataAPI(inputData) {
    return httpTokenCommon.post(
      "Payment/GetCustomerAgeingPaymentData",
      inputData
    );
  }
  getPaymentInvoiceDataAPI(inputData) {
    return httpTokenCommon.post("Payment/GetInvoiceWisePaymentData", inputData);
  }
  getDistributionchannelDataAPI() {
    return httpTokenCommon.post("Payment/GetDistributionchannel");
  }
  getCountryDataAPI() {
    return httpTokenCommon.post("Payment/GetCountryList");
  }
  getPrinceGroupDataAPI() {
    return httpTokenCommon.post("Payment/GetPriceGroup");
  }
  getSalesOfficeDataAPI() {
    return httpTokenCommon.post("Payment/GetSalesOffice");
  }
  getYearsDataAPI(inputData) {
    return httpTokenCommon.post("Payment/GetYearOutstandingReport", inputData);
  }
}

const paymentService = new PaymentService();
export default paymentService;
